import instObj from '@/backend/axios-instances'

const resource = "/boms/details"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    // bom_id in body
    return instance.post(resource, data, { params: parameters });
  },
  addSlab(data, parameters) {
    // bom_id and production_sheet_item_id in parameter
    return instance.post(`${resource}/slabs`, data, { params: parameters });
  },
  deleteSlab(bomDetailId) {
    return instance.delete(bomDetailId);
  }
}
